import { render, staticRenderFns } from "./ProjectSmallCard.vue?vue&type=template&id=2b311f5c&scoped=true&"
import script from "./ProjectSmallCard.vue?vue&type=script&lang=js&"
export * from "./ProjectSmallCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSmallCard.vue?vue&type=style&index=0&id=2b311f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b311f5c",
  null
  
)

export default component.exports